export default __webpack_public_path__ + "static/media/Tube-Bead-and-bell.6e1a52be.jpg";